module.exports = __webpack_public_path__ + "img/2_AtR_m.a85fcfff.jpg";